import { TranslationKey } from '~/lib';
import {
    ALGOLIA_INDEX_MAIN,
    ALGOLIA_INDEX_SORT_DISCOUNT_PERCENT_DESC,
    ALGOLIA_INDEX_SORT_NEWEST_DESC,
    ALGOLIA_INDEX_SORT_PRICE_ASC,
    ALGOLIA_INDEX_SORT_PRICE_DESC,
    ALGOLIA_INDEX_SORT_RATINGS_DESC,
} from '~/services/instantsearch/variables';

export type AlgoliaSortOption = {
    value: string;
    label: TranslationKey;
};

export const algoliaSortOptions: AlgoliaSortOption[] = [
    {
        label: 'plp.sortPopular',
        value: ALGOLIA_INDEX_MAIN,
    },
    {
        label: 'plp.sortPriceAsc',
        value: ALGOLIA_INDEX_SORT_PRICE_ASC,
    },
    {
        label: 'plp.sortPriceDesc',
        value: ALGOLIA_INDEX_SORT_PRICE_DESC,
    },
    {
        label: 'plp.sortDiscountPercentDesc',
        value: ALGOLIA_INDEX_SORT_DISCOUNT_PERCENT_DESC,
    },
    {
        label: 'plp.sortNewestDesc',
        value: ALGOLIA_INDEX_SORT_NEWEST_DESC,
    },
    {
        label: 'plp.sortRatingsDesc',
        value: ALGOLIA_INDEX_SORT_RATINGS_DESC,
    },
];
